import fetchPost from '@/api/http.js'

export default {
    actions: {
        getOrderEnquiryListApi({}, data) {
            return fetchPost('/saas/orderEnquiry/queryList', data)
        },
        orderEnquiryApi({}, data) {
            return fetchPost('/saas/orderEnquiry/enquiry', data)
        },
        getOrderEnquiryDetailApi({}, data) {
            return fetchPost('/saas/orderEnquiry/queryDetail', data)
        },
        cancelOrderEnquiryApi({}, data) {
            return fetchPost('/saas/orderEnquiry/cancelOrderEnquiry', data)
        },
        confirmOrderEnquiryApi({}, data) {
            return fetchPost('/saas/orderEnquiry/confirmOrderEnquiry', data)
        },
        quotedPriceQueryListApi({}, data) {
            return fetchPost('/saas/orderEnquiry/quotedPriceQueryList', data)
        },
    }
}
